<template>

  <div class="adp-modal-row adp-modal-competence-block-inputs">
    <div>
      <div class="d-flex justify-content-between align-items-baseline">
        <label class="adp-p adp-p__grey">{{ $t('catalog.competence') }} {{ competenceNumber }}* ({{ $t('modal.required_field') }})</label>
        <button class="btn adp-btn-outline float-right" v-if="hasDeleteButton" @click="deleteCompetence">
          {{ $t('catalog.clear_competence') }}
        </button>
      </div>
      <v-select :options="notSelectedCompetencies" label="name" v-model="competence"
                :placeholder="$t('catalog.choose_competence')" :filterable="true"
                @input="option => selectCompetence()">
      </v-select>

      <div class="d-flex adp-modal-row flex-wrap" v-if="(skillOptions[0] && skillOptions[0].id !== undefined) && (skillOptions[0].id !== null)">
        <div class="adp-modal-skill-inputs" v-for="(skill, i) in skills" :key="i">
          <div class="adp-p adp-p__grey mb-2" :class="{invisible: i !== 0, 'd-none': i > 1}" style="width: max-content">
            {{ $t('catalog.skills') }}
          </div>
          <v-select :options="notSelectedSkills" v-model="skills[i]" label="name"
                    :placeholder="$t('catalog.choose_skill')" @input="option => changeCompetenceObject()">
          </v-select>
        </div>
        <div class="adp-modal-skill-add-block" v-if="skills.length < skillOptions.length" style="padding-bottom: 15px"
             :style="skills.length % 2 === 0 ? 'justify-content: flex-start' : 'justify-content: flex-end'">
          <div>
            <button class="btn adp-btn-outline float-right" @click="() => (skills.push(null))">
              {{ $t('catalog.add_another_skill') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "CompetenceSkillsBlock",
  props: {
    competenceObj: {
      type: Object,
      default: function () {
        return {id: null, name: null, skills: [null]};
      },
    },
    hasDeleteButton: {
      type: Boolean,
      default: false,
    },
    competenceNumber: {
      type: Number,
    },
    competenceList: {
      type: Array,
    },
    notSelectedCompetencies: {
      type: Array,
    },
  },
  data: function () {
    return {
      competence: this.competenceObj,
      skills: (this.competenceObj && this.competenceObj.skills) || [null],
      notSelectedSkills: [],
      skillOptions: [],
    }
  },
  watch: {
    competenceObj(newVal) {
      this.competence = newVal;
      if (newVal && newVal.id) {
        this.skills = newVal.skills;
      } else {
        this.skills = [null];
      }
      this.updateSkillOptions();
    },
  },
  methods: {
    deleteCompetence() {
      this.$emit('delete-competence');
    },
    selectCompetence() {
      this.changeCompetenceObject();
      this.$emit('select-competence');
    },
    changeCompetenceObject() {
      if (this.competence && this.competence.id) {
        this.$emit('change-competence-object', {id: this.competence.id, name: this.competence.name, skills: this.skills});
      } else {
        this.$emit('change-competence-object', {id: null, name: null, skills: [null]});
      }
      this.updateSkillOptions();
    },
    updateSkillOptions() {
      if (this.competenceObj && this.competenceObj.id) {
        let selectableCompetence = this.competenceList.find(x => x.id === this.competenceObj.id);
        this.skillOptions = selectableCompetence && selectableCompetence.skills || [];

        let selectedIds = this.competenceObj.skills.filter(e => e).map(e => e.id);
        this.notSelectedSkills = this.skillOptions.filter(e => e && selectedIds.includes(e.id) !== true);
      } else {
        this.skillOptions = [];
        this.notSelectedSkills = [];
      }
    },
  },
  mounted() {
    this.updateSkillOptions();
  }
}
</script>
